export const DEFAULT_GET_AUDIENCE_VARIABLES = {
    limit: 100,
    sort: 'CREATED_TIME_DESC',
} as const;

export const DEFAULT_LIST_ID_MAP = {
    contacts: '1000001-filters',
    accounts: '1000000-filters',
    leads: '1000002-filters',
} as const;
